export default __webpack_public_path__ + "static/media/Leggings of the Faceless Spinx.a1257013.jpg";